import { LuzmoDashboardComponent } from '@luzmo/react-embed';
import { FunctionComponent } from 'react';
import { useQuery } from 'react-query';
import { GET_INVENTORY_ALLOCATION_MOVEMENTS_DASHBOARD } from '../../../api/inventory-allocation-reports';
import { InventoryAllocation } from '../../../shared/models/inventoryAllocation';
import { InventoryAllocationReport } from '../../../shared/models/inventoryAllocationReport';
import { GetReportDashboardResponseDTO } from '../../../shared/models/schema';

interface Props {
	reportId: InventoryAllocationReport['id'];
	allocationId: InventoryAllocation['id'];
}

const InventoryAllocationReportMovements: FunctionComponent<Props> = ({
	reportId,
	allocationId,
}) => {
	const { isLoading, data } = useQuery<
		unknown,
		{},
		GetReportDashboardResponseDTO
	>(['movement-dashboard', allocationId, reportId], () =>
		GET_INVENTORY_ALLOCATION_MOVEMENTS_DASHBOARD(allocationId, reportId),
	);

	if (isLoading) {
		return <p>Loading...</p>;
	}

	return (
		<div id="cumulio-container">
			<LuzmoDashboardComponent
				dashboardId={data?.dashboard_id}
				authKey={data?.id}
				authToken={data?.token}
				loaderBackground="transparent"
				loaderFontColor="transparent"
				loaderSpinnerColor="#6111C7"
				loaderSpinnerBackground="transparent"
			/>
		</div>
	);
};

export default InventoryAllocationReportMovements;
